import { createFileRoute } from "@tanstack/react-router";

import { Reveal } from "@/components/site/motion";
import { getDict, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/privacy")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.legal.privacy.title} · insidermark` }, { name: "description", content: t.legal.privacy.intro }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const d = t.legal.privacy;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{d.title}</h1>
            <p className="im-body-text mt-5">{d.intro}</p>
            <p className="im-mono mt-4">{t.legal.updated}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <div className="im-prose im-legal">
            {d.sections.map((s) => (
              <section key={s.h}>
                <h2 className="im-h3">{s.h}</h2>
                {s.p.map((x) => (
                  <p key={x}>{x}</p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
